import { origin } from '../helpers/projectConstant';
import { ITotalFormValue } from '../pages/ExpertPlatformSubmitQuestion/IExpertPlatformSubmitQuestion';

// eslint-disable-next-line import/prefer-default-export
export const submitQuestion = async (
  formData: ITotalFormValue
): Promise<void> => {
  const apiBody = new URLSearchParams({
    Name: formData.name,
    EmailAddress: formData.email,
    Question: formData.question,
  }).toString();

  const headers: HeadersInit = {
    'Content-Type': 'application/x-www-form-urlencoded',
    ...(formData.forgeryToken !== null && { 'RequestVerificationToken': formData.forgeryToken })
  };

  const response = await fetch(`${origin}/QuestionSave`, {
    method: 'POST',
    headers,
    body: apiBody,
  });

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
};
